<template>
    <div>
        <!--<div class="overlay" @click="ocultar"></div>-->
        <div class="overlay"></div>
        <div class="component-container">
            <div class="modal">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            ocultar: Function
        }
    }
</script>

<style lang="scss" scoped>
    .component-container {
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        z-index: 255;
    }

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.75);
        height: 100%;
        width: 100%;
        z-index: 250;
    }

    .modal {
        z-index: 260;
        position: fixed;
        min-width: 711px;
        max-width: 711px;
        min-height: 500px;
        min-height: 500px;
        background-color: white;
    }
</style>
